var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEuroSymbolCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.5C20.49 26.5 18.32 25.08 17.24 23H23V21H16.58C16.53 20.67 16.5 20.34 16.5 20C16.5 19.66 16.53 19.33 16.58 19H23V17H17.24C18.32 14.92 20.5 13.5 23 13.5C24.61 13.5 26.09 14.09 27.23 15.07L29 13.3C27.41 11.87 25.3 11 23 11C19.08 11 15.76 13.51 14.52 17H11V19H14.06C14.02 19.33 14 19.66 14 20C14 20.34 14.02 20.67 14.06 21H11V23H14.52C15.76 26.49 19.08 29 23 29C25.31 29 27.41 28.13 29 26.7L27.22 24.93C26.09 25.91 24.62 26.5 23 26.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEuroSymbolCircle40Px);
export default __webpack_public_path__ + "static/media/ic_euro_symbol_circle-40px.3b5f77323a71a4e697eff3aac3493203.svg";
export { ForwardRef as ReactComponent };